// extracted by mini-css-extract-plugin
export var container = "_gd-1";
export var editor = "_gd-2";
export var resizable = "_gd-3";
export var wrapper = "_gd-0";